import React from 'react';
import './TemplatesSection.scss';
import Container from 'reactor/components/Grid/ContainerWithWidth';
import GridItem from 'reactor/components/Grid/GridItem';
import Heading from './../../components/heading';
import Masonry from "react-masonry-css";
import ArrowDiagonalTop from './../../components/ArrowDiagonalTop';
// import { makeStyles } from '@material-ui/core';
import Tilt from "./../../components/component";


const Templates = [
    {
        id: 1,
        title: 'قالب الشركات ',
        templatename: "الشركات",
        subtitle: 'قالب الشركات التعريفي',
        height: '22rem',
        mobileHeight: '130px',
        color: '#5439fb',
        href: 'https://demo2.rh.net.sa/templates/companies/template1/',
        content: "منفذ بأحدث التقنيات، يساعدك على نجاح شركتك التجارية، من خلال التعريف عن الشركة، وأهدافها، والخدمات التي تقدمها للوصول الى العملاء المستهدفين لك."
    },
    {
        id: 2,
        title: 'قالب المحاماة',
        templatename: "المحاماة",
        subtitle: 'قالب باللون الاسود',
        height: '26rem',
        mobileHeight: '160px',
        color: '#000',
        href: 'https://demo2.rh.net.sa/templates/lawyer/template1/',
        content: 'منفذ بأحدث التقنيات، يساعدك على نجاح مكتبك القانوني، من خلال التعريف عنه، واستعراض الأهداف، والخدمات التي تقدمها للوصول العملاء المستهدفين لك.'
    },
    {
        id: 3,
        title: 'قالب المحاماة',
        templatename: "المحاماة",
        subtitle: 'قالب باللون الفاتح',
        height: '22rem',
        mobileHeight: '120px',
        color: '#ccaf6c',
        href: 'https://demo2.rh.net.sa/templates/lawyer/template2/',
        content: 'منفذ بأحدث التقنيات، يساعدك على نجاح مكتبك القانوني، من خلال التعريف عنه، واستعراض الأهداف، والخدمات التي تقدمها للوصول العملاء المستهدفين لك.'
    },
    {
        id: 4,
        title: 'قالب الجمعيات',
        templatename: "الجمعيات",
        subtitle: 'قالب الجمعيات الأهلية',
        height: '22rem',
        mobileHeight: '120px',
        color: '#146b7b',
        href: 'https://demo2.rh.net.sa/templates/charity/template1/',
        content: "منفذ بأحدث التقنيات، يحتوي على الكثير من المميزات مثل التحكم وادارة المحتوى، وعرض صور الجمعية، كتابة المشاريع المقدمة وأنشطتها، عرض الأعمال التي تقوم بها الجمعية مع امكانية التبرع الإلكتروني."
    }
];

export default function TemplatesSection() {

    // const useStyles = makeStyles(theme => ({
    //     contentBody: {
    //         maxWidth: '1120px',
    //         [theme.breakpoints.down('600')]: {
    //             width: 'auto',
    //             display: 'block'
    //         },
    //         [theme.breakpoints.up('1367')]: {
    //             maxWidth: '1760px',
    //         },
    //     }
    // }));
    // const classes = useStyles();
    const isMobile = window.innerWidth < 768;
    return (
        <div id="templates__section">
            <Container>
                <GridItem  md={4} sm={12} xs={12}>
                    <Heading title="قوالب رواد."
                        subtitle="قوالب قيّمة <br/> بقيمة مذهلة."
                        notify="قمنا بتوفير قوالب متعددة الاستخدام تناسب جميع الفئات (شركات - افراد) بأسعار مميزة، وتشكيلة واسعة من قوالب إدارة المحتوى."
                    />
                    <h4>بضغطة زر احصل على موقع الكتروني…</h4>
                    {/* <MoreLink href="/templates" linkname="المزيد من <br/> المعلومات" /> */}

                </GridItem>
                <GridItem md={8} sm={12} xs={12}>
                        <Masonry
                            breakpointCols={{350: 2, 600: 2, 900: 2}}
                            className="my-masonry-grid"
                            columnClassName="my-masonry-grid_column"
                            >
                            { Templates.map((template,index) => (
                                <div
                                    key={index}
                                    // style={{
                                    //     height: template.height,
                                    //     color: template.color ,
                                    //     borderColor: template.color,
                                    // }}
                                    // key={index} className="template__item"
                                >
                                    <a href={template.href} style={{
                                        color: template.color
                                    }} target='_blank'>
                                        <div className="template__item-shadow" style={{ background: template.color }}></div>
                                        <Tilt
                                            style={{
                                                height: isMobile ? template.mobileHeight : template.height,
                                                color: template.color ,
                                                borderColor: template.color,
                                              
                                            }}
                                            className="template__item"
                                        >
                                            <ArrowDiagonalTop color={template.color} />
                                            <div className="template__item--caption">
                                                <h3 className="template__item--title">قالب <br/>{template.templatename}</h3>
                                                <p className="template__item--subtitle">{template.subtitle}</p>
                                            </div>
                                            <div className="template__item--content">
                                                <p className="template__item--inner--content">{template.content}</p>
                                            </div>
                                        </Tilt>
                                    </a>
                                </div>
                            ))}
                        </Masonry>

                </GridItem>
            </Container>
        </div>
    )
}